var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pagination-container"},[_c('el-pagination',{attrs:{"current-page":_vm.page,"page-sizes":[10, 20, 30],"page-size":_vm.limit,"layout":"total, sizes, prev, pager, next, jumper","total":_vm.total},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }